import { MuiListItemButtonTheme } from "../List/ListItemButton.theme";
export const MuiMenuItemTheme = (dt) => {
    return MuiListItemButtonTheme(dt);
};
